"use client";

import { useState, type ReactNode } from "react";
import { BoolToggle } from "@app-foundation/ui-controls";
import "@app-foundation/ui-controls/styles.css";
import { LocalOnboardingPreview } from "./LocalOnboardingPreview";

import { VerificationQrContext, ViewStepContext } from "./local-view-context";

export function LocalFlowViewer({ enabled, identity = "creator", children }: {
  enabled: boolean; registration?: boolean; identity?: "creator" | "brand" | "director" | "agent"; children: ReactNode;
}) {
  const [verificationQr, setVerificationQr] = useState<string | null>(null);
  const [viewing, setViewing] = useState(true);
  const [index, setIndex] = useState<number | null>(null);
  if (!enabled) return children;
  const select = (position: number) => setIndex(position);
  return <VerificationQrContext.Provider value={setVerificationQr}><ViewStepContext.Provider value={viewing ? select : undefined}>
    <div className="mb-4 flex flex-wrap items-center justify-center gap-3 text-sm">
      <BoolToggle label="自由查看" value={viewing} onChange={value => { setViewing(value); setIndex(null); }} />
    </div>
    <div hidden={viewing && index !== null}>{children}</div>
    {viewing && index !== null && <LocalOnboardingPreview embedded verificationQr={verificationQr} initialIdentity={identity} indexOverride={index} onSelectStep={select} />}
  </ViewStepContext.Provider></VerificationQrContext.Provider>;
}
